export default __webpack_public_path__ + "03cb3c4ca3e9e7ec9d8d92e0f9844cbf.png";